module.exports = __webpack_public_path__ + "media/images/certificates/certificat-04-39aa92ead28c002ff4cf71a70eafb3e4.svg";